import Vue from 'vue';
export default{
    getTimbres(parametros){
        return Vue.axios.get("nominas-timbres/lista_recibos", {params: parametros}).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
}